import { useState } from 'react'
import { Star, ChevronRight, Rocket } from 'lucide-react'
import { format } from 'date-fns'
import { STATUSES, SERVICE_AREAS, getStatus } from './constants'

export default function OnboardingSpotlight({ clients, tasks, onClientClick, onRunKickoff }) {
  const onboardingClients = clients.filter(c => c.is_onboarding && !c.onboarding_complete)

  if (!onboardingClients.length) return null

  return (
    <div className="onboarding-spotlight">
      <div className="spotlight-header">
        <Star size={18} fill="var(--gold)" color="var(--gold)" />
        <h2>New Client Onboarding</h2>
        <span className="spotlight-badge">{onboardingClients.length} active</span>
      </div>
      <div className="spotlight-grid">
        {onboardingClients.map(client => {
          const clientTasks = tasks.filter(t => t.client_id === client.id && t.is_onboarding_task)
          const total = clientTasks.length
          const done = clientTasks.filter(t => t.status === 'approved').length
          const inProgress = clientTasks.filter(t => t.status === 'in_progress').length
          const blocked = clientTasks.filter(t => t.status === 'blocked').length
          const pct = total ? Math.round((done / total) * 100) : 0

          // Group by week
          const weeks = {}
          clientTasks.forEach(t => {
            const w = t.week_number || 0
            if (!weeks[w]) weeks[w] = { total: 0, done: 0 }
            weeks[w].total++
            if (t.status === 'approved') weeks[w].done++
          })
          const weekNums = Object.keys(weeks).map(Number).sort((a, b) => a - b)

          return (
            <div key={client.id} className="spotlight-card" onClick={() => onClientClick(client.id)}>
              <div className="spotlight-card-header">
                <div>
                <div className="spotlight-card-name">{client.name}</div>
                {client.start_date && (
                  <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginTop: 2 }}>
                    Started {format(new Date(client.start_date + 'T12:00:00'), 'MMM d, yyyy')}
                  </div>
                )}
              </div>
                <ChevronRight size={16} style={{ opacity: 0.6 }} />
              </div>
              <div className="spotlight-card-body">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{done}/{total} tasks complete</span>
                  <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--teal)' }}>{pct}%</span>
                </div>
                <div className="progress-bar-wrap">
                  <div className="progress-bar-fill" style={{ width: pct + '%' }} />
                </div>
                <div className="progress-label">
                  <span>{inProgress} in progress</span>
                  {blocked > 0 && <span style={{ color: 'var(--red)' }}>⚠ {blocked} blocked</span>}
                </div>

                {weekNums.length > 0 && (
                  <div className="week-chips">
                    {weekNums.filter(w => w > 0).map(w => {
                      const wk = weeks[w]
                      const allDone = wk.done === wk.total
                      const hasProgress = wk.done > 0 && !allDone
                      return (
                        <span key={w} className={`week-chip ${allDone ? 'done' : hasProgress ? 'active' : 'pending'}`}>
                          Wk {w}
                        </span>
                      )
                    })}
                  </div>
                )}

                {/* Service area breakdown */}
                <div style={{ marginTop: 10, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                  {SERVICE_AREAS.filter(sa => clientTasks.some(t => t.service_area === sa.value)).map(sa => {
                    const saTasks = clientTasks.filter(t => t.service_area === sa.value)
                    const saDone = saTasks.filter(t => t.status === 'approved').length
                    return (
                      <span key={sa.value} style={{
                        fontSize: 11, padding: '2px 8px', borderRadius: 20,
                        background: sa.color + '18', color: sa.color, fontWeight: 500
                      }}>
                        {sa.label} {saDone}/{saTasks.length}
                      </span>
                    )
                  })}
                </div>

                {/* Kickoff Builder action */}
                {onRunKickoff && (
                  <button
                    onClick={e => { e.stopPropagation(); onRunKickoff(client) }}
                    style={{
                      marginTop: 12, width: '100%', padding: '8px 12px',
                      background: 'var(--gold)', color: '#fff', border: 'none', borderRadius: 8,
                      fontSize: 12.5, fontWeight: 600, cursor: 'pointer',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                    }}
                  >
                    <Rocket size={13} />
                    {total === 0 ? 'Run Kickoff Builder' : 'Add more tasks'}
                  </button>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}